import {gql, useLazyQuery} from "@apollo/client";

export const ORGANIZATION_BLANK_IMPORT_TEMPLATE = gql`
    query OrganizationBlankImportExcelTemplate($organizationId: Int!, $maxRows: Int) {
        organizationBlankImportExcelTemplate(
            organizationId: $organizationId
            maxRows: $maxRows
        ) {
            filename
            contentBase64
            mimeType
        }
    }
`;

export function useOrganizationBlankImportExcelTemplate() {
    return useLazyQuery(ORGANIZATION_BLANK_IMPORT_TEMPLATE, {
        fetchPolicy: "no-cache",
    });
}

export const VALIDATE_ORGANIZATION_IMPORT = gql`
    mutation ValidateOrganizationImport(
        $organizationId: Int!
        $sheets: GenericScalar!
        $mappings: GenericScalar!
    ) {
        validateOrganizationImport(
            organizationId: $organizationId
            sheets: $sheets
            mappings: $mappings
        ) {
            success
            errors
            summary
        }
    }
`;

export const IMPORT_ORGANIZATION_STRUCTURE = gql`
    mutation ImportOrganizationStructure(
        $organizationId: Int!
        $sheets: GenericScalar!
        $mappings: GenericScalar!
    ) {
        importOrganizationStructure(
            organizationId: $organizationId
            sheets: $sheets
            mappings: $mappings
        ) {
            success
            errors
            summary
        }
    }
`;

export const SEND_IMPORTED_ACCOUNT_ACTIVATIONS = gql`
    mutation SendImportedAccountActivations($organizationId: Int!) {
        sendImportedAccountActivations(organizationId: $organizationId) {
            success
            errors
            summary
        }
    }
`;

export const GET_IMPORTED_ACCOUNT_ACTIVATIONS = gql`
    query ImportedAccountActivations($organizationId: Int!, $status: String, $accountType: String, $q: String, $page: Int, $pageSize: Int) {
        pendingImportedAccountActivations(
            organizationId: $organizationId
            status: $status
            accountType: $accountType
            q: $q
            page: $page
            pageSize: $pageSize
        ) {
            count
            pendingCount
            sentCount
            activatedCount
            objects {
                id
                fullName
                email
                accountType
                status
                lastActivationSentAt
            }
        }
    }
`;

export const GET_IMPORTED_ACCOUNT_ACTIVATION_SUMMARY = gql`
    query ImportedAccountActivationSummary($organizationId: Int!) {
        pendingImportedAccountActivations(organizationId: $organizationId) {
            pendingCount
            sentCount
            activatedCount
        }
    }
`;

export const SEND_IMPORTED_ACCOUNT_ACTIVATION = gql`
    mutation SendImportedAccountActivation($organizationId: Int!, $accountId: Int!) {
        sendImportedAccountActivation(
            organizationId: $organizationId
            accountId: $accountId
        ) {
            success
            errors
            summary
        }
    }
`;
